export enum ZoomEnum {
  IN = 10,
  OUT = -10,
  FIT = 0,
}
